export const SERVER_FIELD_MAP: Record<string, string> = {
  user_first_name: 'firstName',
  user_family_name: 'familyName',
  user_initials: 'initials',
  user_birthdate: 'birthdate',
  user_portrait: 'portrait',
  user_signature: 'signature',
  user_phone: 'phone',
  user_mobile: 'mobile',
  user_email_private: 'emailPrivate',
  user_mobile_private: 'mobilePrivate',
  user_phone_private: 'phonePrivate',
  user_address_line_1: 'addressLine1',
  user_address_line_2: 'addressLine2',
  user_city: 'city',
  user_postcode: 'postcode',
  user_ctry: 'country',
  user_joti: 'jobTitleId',
  user_user_manager: 'manager',
  user_user_hr: 'hr',
  user_team: 'team',
  user_dept: 'department',
  user_user_deputy: 'deputy',
  salary_saly_start: 'salaryStartDate',
  salary_saly_end: 'salaryEndDate',
  salary_saly_percentage: 'salaryPercentage',
  salary_saly_rank: 'rankId',
  salary_saly_monthly_salary: 'salaryType',
  salary_saly_monthly: 'salaryMonthly',
  salary_saly_hourly: 'salaryHourly',
  user_emergency_contact1: 'emergency.0.contact',
  user_emergency_relationship1: 'emergency.0.relationship',
  user_emergency_mobile1: 'emergency.0.mobile',
  user_emergency_email1: 'emergency.0.email',
  user_emergency_contact2: 'emergency.1.contact',
  user_emergency_relationship2: 'emergency.1.relationship',
  user_emergency_mobile2: 'emergency.1.mobile',
  user_emergency_email2: 'emergency.1.email',
};
